export const Types = {
  GET_REQUEST: 'roles/GET_REQUEST',
  GET_SUCCESS: 'roles/GET_SUCCESS',
  GET_FAILURE: 'roles/GET_FAILURE',

  GET_LIST_REQUEST: 'roles/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'roles/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'roles/GET_LIST_FAILURE',

  CREATE_REQUEST: 'roles/CREATE_REQUEST',
  CREATE_SUCCESS: 'roles/CREATE_SUCCESS',
  CREATE_FAILURE: 'roles/CREATE_FAILURE',

  UPDATE_REQUEST: 'roles/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'roles/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'roles/UPDATE_FAILURE',
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  create: {
    loading: false,
  },

  update: {
    loading: false,
  },
};

export default function roles(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.role,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.roles.data,
        page: action.payload.roles.meta.current_page,
        totals: action.payload.roles.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.CREATE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    case Types.CREATE_SUCCESS:
    case Types.CREATE_FAILURE:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getRoleRequest: id => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getRoleSuccess: role => ({
    type: Types.GET_SUCCESS,
    payload: { role },
  }),

  getRoleFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getRolesRequest: (page = 1) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page },
  }),

  getRolesSuccess: roles => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { roles },
  }),

  getRolesFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  createRoleRequest: data => ({
    type: Types.CREATE_REQUEST,
    payload: { data },
  }),

  createRoleSuccess: () => ({
    type: Types.CREATE_SUCCESS,
  }),

  createRoleFailure: () => ({
    type: Types.CREATE_FAILURE,
  }),

  updateRoleRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateRoleSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateRoleFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),
};
